
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'
import { FirebaseProvider } from './contexts/FirebaseContext'
import { AuthProvider } from './contexts/AuthContext'
import React from 'react'

// Ensure the container element exists
const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

// Create a React root and render the app with all providers
createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <FirebaseProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </FirebaseProvider>
    </BrowserRouter>
  </React.StrictMode>
);
